import * as React from 'react';
import { EditorUtils } from '@progress/kendo-react-editor';
import { plusIcon } from '@progress/kendo-svg-icons';
import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';

interface Shortcode {
  text: string;
  code: string;
  id: number;
}

var shortcodes: Shortcode[] = [
  { text: 'Name', code: '«name»', id: 1 },
  { text: 'Initials', code: '«initials»', id: 2 },
  { text: 'Address', code: '«address_street»', id: 3 },
  { text: 'Email', code: '«email»', id: 4 },
  { text: 'Phone', code: '«phone»', id: 5 },
];

export function setShortcodeData (data: []) {
  shortcodes = data.map((fieldData: any) => {
    return {text: fieldData.fieldname,  code: '<' + fieldData.fieldname + '>', id: 1}
  })
}

const defaultItem: Shortcode = { text: 'Insert Field', code: '', id: 0 };

interface InsertShortcodeToolProps {
  view: any; // Replace 'any' with the appropriate type if known
}

export class InsertShortcodeTool extends React.Component<InsertShortcodeToolProps> {
  handleShortcodeInsert = (event: DropDownButtonItemClickEvent) => {
    const selectedShortcode = event.item as Shortcode;

    if (!selectedShortcode.code) {
      return;
    }

    const { view } = this.props;
    const schema = view.state.schema;

    const nonEditableNodeType = schema.nodes.nonEditable;

    const shortcodeNode = nonEditableNodeType.createAndFill(
      { class: 'shortcode' },
      schema.text(selectedShortcode.code)
    );

    EditorUtils.insertNode(view, shortcodeNode);
    view.focus();
  };

  render() {
    const { view } = this.props;
    const canInsertTextNode = view && EditorUtils.canInsert(view.state, view.state.schema.nodes.text);

    return (
      <DropDownButton
        text="Field Codes"
        items={shortcodes}
        iconClass='k-icon k-i-plus'
        //svgIcon={plusIcon}
        disabled={!canInsertTextNode}
        onItemClick={this.handleShortcodeInsert}
        style={{ userSelect: 'none' }}
      />
    );
  }
}
